module.exports = __webpack_public_path__ + "img/login_spore.7b35ba7f.png";